import { generateAnalyticSummaryPageData } from 'HelperFiles/DataGenerator';
import { wholeDataGenerator } from 'HelperFiles/DataGenerator';
import { handleDateFormat } from 'HelperFiles/DateHelper';
import { initialAnalyticSummaryPageData } from 'Redux/DashboardVariables';
import { setAnalyticSummaryPageData } from 'Redux/DashboardVariables';
import { setSearchEndDate } from 'Redux/DashboardVariables';
import { setSearchStartDate } from 'Redux/DashboardVariables';
import { setWholeData } from 'Redux/DashboardVariables';
import { API_SUCCESS, API_FAILED, apiAction } from '../core/apiCoreRedux';
const FETCH_GET_EVENTS_ONLY = 'FETCH_GET_EVENTS_ONLY';

// actions
export const callGetEvents = (data, successCallback = () => { }, failureCallback = () => { }) => ({
  type: FETCH_GET_EVENTS_ONLY,
  payload: {
    data,
    successCallback,
    failureCallback
  }
});

// Middleware
export const callGetEventsMidlleware =
  ({ dispatch, getState }) =>
    (next) =>
      (action) => {
        next(action);
        switch (action.type) {
          case FETCH_GET_EVENTS_ONLY:
            dispatch(setCallGetEventsLoader(true));
            const { data: {
              resetSearchDate,
              abortControllerArrRef
            }, successCallback, failureCallback } = action.payload;

            let endTimeValue = resetSearchDate
              ? new Date(new Date().setHours(23, 59, 59, 999)).getTime()
              : new Date(getState().searchEndDate).getTime();
            let startTimeValue = resetSearchDate
              ? new Date().getTime() - 3600 * 1000
              : new Date(getState().searchStartDate).getTime();
            let startTimeStr = handleDateFormat(startTimeValue);
            let endTimeStr = handleDateFormat(endTimeValue);
            let apiData = {
              locations: getState().locationsData.map(location => location.id),
              cameras: [],
              startTime: startTimeValue,
              endTime: endTimeValue,
              duration: endTimeValue - startTimeValue,
              incidentTypes: getState().allIncidents.apiCallAllEvents,
              limit: 0,
              offset: 0,
              startTimeStr: startTimeStr,
              endTimeStr: endTimeStr,
              eventValidFlag: "ALL"
            };
            if (resetSearchDate) {
              dispatch(setSearchStartDate(new Date(startTimeValue)));
              dispatch(setSearchEndDate(new Date(endTimeValue)));
            }
            // const tempAbortControllerArrRef = addAbortController ? abortControllerArrRef : null;
            dispatch(
              apiAction({
                url: `:8989/get_events`,
                actionType: FETCH_GET_EVENTS_ONLY,
                data: apiData,
                meta: { successCallback, failureCallback },
                method: 'POST',
                abortControllerArrRef
              })
            );
            break;

          case `${FETCH_GET_EVENTS_ONLY} ${API_SUCCESS}`:
            dispatch(setCallGetEventsLoader(false));
            const wholeData = wholeDataGenerator(action.payload.incidents);
            const analyticSummaryPageData = generateAnalyticSummaryPageData({
              wholeData,
              locationSelected: getState().locationSelected,
              cameraSelected: getState().cameraSelected,
              cameraData: getState().cameraData,
              locationsData: getState().locationsData,
              searchStartDate: getState().searchStartDate,
              searchEndDate: getState().searchEndDate,
              allIncidents: getState().allIncidents,
              selectedIncidents: getState().selectedIncidents,
              applicationConfig: getState().applicationConfig
            });

            dispatch(setWholeData(wholeData));
            dispatch(setAnalyticSummaryPageData(analyticSummaryPageData));
            dispatch(setCallGetEventsLoader(false));
            action.meta.successCallback();
            break;

          case `${FETCH_GET_EVENTS_ONLY} ${API_FAILED}`:
            dispatch(setWholeData([]));
            dispatch(setAnalyticSummaryPageData(generateAnalyticSummaryPageData({
              applicationConfig: getState().applicationConfig,
              allIncidents: getState().allIncidents
            })));
            dispatch(setCallGetEventsLoader(false));
            action.meta.failureCallback();

          default:
          // nothing to be done
        }
      };

// Api check variables
export const setCallGetEventsLoader = (data) =>
  ({ type: 'CALL_GET_EVENTS_LOADER', payload: data });
export const callGetEventsLoaderReducer = (state = false, action = { type: '', payload: false }) => {
  if (action.type === 'CALL_GET_EVENTS_LOADER') { return action.payload; } else { return state; }
};
export const getCallGetEventsLoader = (state) => state.callGetEventsLoader;


